import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    hintButton: {
        minWidth: 'auto',
        padding: tokens.spacingHorizontalXXS,
        color: tokens.colorNeutralForeground3,
        ':hover': {
            color: tokens.colorNeutralForeground2,
            backgroundColor: tokens.colorNeutralBackground3Hover,
        },
        ':active': {
            color: tokens.colorNeutralForeground2Pressed,
            backgroundColor: tokens.colorNeutralBackground3Pressed,
        },
    },
    popoverSurface: {
        maxWidth: '400px',
        padding: tokens.spacingVerticalM,
    },
});
